import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { QRCodeSVG } from 'qrcode.react';
import axios from 'axios';
import StoreBadges from '../components/StoreBadges';
import './PublicWebinarRegister.css';

const API = window.location.origin + '/api';
const DL_URL = 'https://prozpects.com/dl';

export default function PublicWebinarRegisterSuccessPage() {
  const { slug } = useParams();
  const [params] = useSearchParams();
  const [status, setStatus] = useState('confirming');

  useEffect(() => {
    const sessionId = params.get('session_id');
    if (!sessionId) { setStatus('done'); return; }
    axios.post(`${API}/webinars/public/confirm`, { session_id: sessionId })
      .then((r) => setStatus(r.data.status === 'registered' ? 'done' : 'pending'))
      .catch(() => setStatus('error'));
  }, [slug, params]);

  return (
    <div className="pwr-shell">
      <div className="pwr-card">
        <img src="/logo-wordmark.png" alt="ProZpects" className="pwr-logo" />
        {status === 'confirming' && <p className="pwr-note">Confirming your registration…</p>}
        {status === 'done' && (
          <>
            <header className="pwr-hero">
              <h1>You're registered! 🎉</h1>
              <p>Check your email for the join link and calendar invite.</p>
            </header>
            <div className="pwr-verified">
              <div className="pwr-dl-heading">Download the ProZpects App</div>
              <div className="pwr-qr">
                <QRCodeSVG value={DL_URL} size={184} level="H"
                  imageSettings={{ src: '/logo.png', height: 42, width: 42, excavate: true }} />
              </div>
              <StoreBadges className="pwr-badges" />
              <p className="pwr-note">Scan the QR code or tap your app store above — or visit{' '}
                <a href={DL_URL} target="_blank" rel="noopener noreferrer" className="pwr-dl-link">prozpects.com/dl</a>
              </p>
            </div>
          </>
        )}
        {status === 'pending' && <p className="pwr-note">Payment is still processing. You'll get a confirmation email shortly.</p>}
        {status === 'error' && <div className="pwr-error" role="alert">We couldn't confirm your payment. Please contact support.</div>}
      </div>
    </div>
  );
}
